import { Link } from "react-router-dom";
import { PreferencesModal } from "./CookieBanner";

export default function Footer() {
  return (
    <footer className="bg-ink text-cream mt-24 grain">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <p className="font-heading font-light text-3xl tracking-editorial leading-tight mb-4">
              Event<span className="font-display italic text-accent">Market</span>
            </p>
            <p className="text-sm text-cream/60 max-w-sm font-light leading-relaxed">
              La marketplace qui réunit organisateurs, exposants et lieux d'exception
              au service de l'événementiel français.
            </p>
          </div>
          <div className="md:col-span-2 md:col-start-7">
            <p className="text-label text-cream/40 mb-5">Découvrir</p>
            <ul className="space-y-2.5 text-sm font-light text-cream/80">
              <li><Link to="/events" className="hover:text-accent transition-colors">Événements</Link></li>
              <li><Link to="/venues" className="hover:text-accent transition-colors">Lieux</Link></li>
              <li><Link to="/providers" className="hover:text-accent transition-colors">Prestataires</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="text-label text-cream/40 mb-5">Devenir</p>
            <ul className="space-y-2.5 text-sm font-light text-cream/80">
              <li><Link to="/register" className="hover:text-accent transition-colors">Organisateur</Link></li>
              <li><Link to="/register" className="hover:text-accent transition-colors">Exposant</Link></li>
              <li><Link to="/register" className="hover:text-accent transition-colors">Lieu</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="text-label text-cream/40 mb-5">Plateforme</p>
            <ul className="space-y-2.5 text-sm font-light text-cream/80">
              <li><Link to="/aide" data-testid="footer-aide" className="hover:text-accent transition-colors">Centre d&apos;aide / FAQ</Link></li>
              <li><Link to="/contact" data-testid="footer-contact" className="hover:text-accent transition-colors">Nous contacter</Link></li>
              <li className="text-cream/60">Commission transparente</li>
              <li className="text-cream/60">Paiements sécurisés</li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-cream/10 flex flex-wrap gap-x-6 gap-y-2 text-xs font-light text-cream/55">
          <Link to="/legal/mentions" data-testid="footer-mentions" className="hover:text-accent transition-colors">Mentions légales</Link>
          <Link to="/legal/cgu" data-testid="footer-cgu" className="hover:text-accent transition-colors">CGU</Link>
          <Link to="/legal/cgv" data-testid="footer-cgv" className="hover:text-accent transition-colors">CGV</Link>
          <Link to="/legal/confidentialite" data-testid="footer-confidentialite" className="hover:text-accent transition-colors">Politique de confidentialité</Link>
          <PreferencesModal>
            <button
              data-testid="footer-manage-cookies"
              className="hover:text-accent transition-colors text-left"
            >
              Gérer les cookies
            </button>
          </PreferencesModal>
          <a href="/contact" data-testid="footer-bottom-contact" className="hover:text-accent transition-colors">Contact</a>
        </div>
        <div className="mt-8 pt-6 border-t border-cream/10 flex flex-col md:flex-row justify-between gap-4 text-[11px] text-cream/40 uppercase tracking-[0.2em]">
          <p>© 2026 EventMarket Pro — Tous droits réservés</p>
          <p className="font-mono normal-case tracking-normal">v1.0 — Édition limitée</p>
        </div>
      </div>
    </footer>
  );
}
